<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                  '单据编号/业务员姓名/设计人员姓名/销售季节/客户名称/工厂名称搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openDetailPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        size="medium"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_proofing_no') || '单据编号'">
              <el-input
                v-model="form.proofingNo"
                :placeholder="
                  $l('form_placeholder_proofing_no') || '请输入单据编号'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_customer_sample_number') || '客户样品款号'"
            >
              <el-input
                v-model="form.cusSampleNo"
                :placeholder="
                  $l('form_placeholder_customer_sample_no') ||
                    '请输入客户样品款号'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_customer') || '客户'">
              <dict-select
                clearable
                v-model="form.listCusCode"
                filterable
                multiple
                size="medium"
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.form_label_designer') || '设计师'">
              <dict-select
                clearable
                v-model="form.listDesignerCode"
                filterable
                multiple
                size="medium"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_designer') ||
                    '请选择设计师'
                "
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_sales_season') || '销售季节'">
              <dict-select
                :placeholder="
                  $l('pe_select_sampleSalesSeason') || '请选择销售季节'
                "
                filterable
                multiple
                size="medium"
                clearable
                v-model="form.listSampleSalesSeason"
                :body="sampleSalesSeasonTypeParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_label_business_name') || '业务人员'"
            >
              <dict-select
                v-model="form.listSalesPersonCode"
                filterable
                multiple
                size="medium"
                clearable
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_business_person') ||
                    '请选择业务人员'
                "
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_proofing_factory') || '打样工厂'"
            >
              <dict-select
                :placeholder="
                  $l('form_placeholder_proofing_factory') || '请选择打样工厂'
                "
                filterable
                multiple
                size="medium"
                clearable
                v-model="form.listScmCode"
                url="/master/common/dict/scmCooperated"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_proofing_status') || '打样单状态'"
            >
              <dict-select
                filterable
                multiple
                size="medium"
                clearable
                v-model="form.listProofingStatus"
                :body="proofingStatusParams"
                url="/sys/common/dict/system"
                :placeholder="
                  $l('form_placeholder_proofing_sheet_status') ||
                    '请选择打样单状态'
                "
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item
            :label="$l('form_label_request_date') || '开发依赖日期'"
          >
            <el-col :span="24">
              <el-col :span="11">
                <el-date-picker
                  v-model="form.requestDateStart"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="form.requestDateEnd"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$l('form_label_finish_date') || '要求完成日期'">
            <el-col :span="24">
              <el-col :span="11">
                <el-date-picker
                  v-model="form.finishDateStart"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="form.finishDateEnd"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            :label="$l('INDEX.form_label_modification_time') || '修改时间'"
          >
            <el-col :span="24">
              <el-col :span="11">
                <el-date-picker
                  v-model="form.modifyDateStart"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="form.modifyDateEnd"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listProofingStatus: ['N', 'Y', 'W','C'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      sampleSalesSeasonTypeParams: { dictType: 'salesSeason' },
      proofingStatusParams: { dictType: 'proofingStatus' },
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', { ...this.form, ...this.regionParams })
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      this.$refs.regionCascader.clearValue()
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
